import { Link } from "react-router-dom";
import { ArrowRight, Users, Clock, Shield, Network, Cpu, Database } from "lucide-react";
import { Reveal, Eyebrow } from "../components/site/Reveal";
import { CTABand } from "../components/site/CTABand";
import { SERVICES } from "../lib/content";

const ICONS = { permanent: Users, contract: Clock, contingent: Shield, network: Network, management: Cpu, systems: Database };

export default function Services() {
  return (
    <>
      <section className="relative overflow-hidden border-b border-slate-200">
        <div className="absolute inset-0 grid-bg" aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
          <Reveal>
            <Eyebrow testId="services-eyebrow">Recruitment services</Eyebrow>
            <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0A1F44] max-w-3xl leading-[1.08]">
              People for your priorities.{" "}
              <span className="text-blue-700">Flexibility for your workforce.</span>
            </h1>
            <p className="mt-7 text-slate-600 text-base md:text-lg leading-relaxed max-w-2xl">
              Whether you are making a permanent hire or engaging contingent workers, we help you find
              people suited to the role, environment and engagement.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.id];
            return (
              <Reveal key={s.id} delay={0.05}>
                <div
                  data-testid={`service-detail-${s.id}`}
                  className="group grid md:grid-cols-[auto_1fr_auto] gap-6 md:gap-10 items-center rounded-2xl border border-slate-200 bg-white p-7 md:p-9 transition-all duration-300 hover:border-blue-600/50 hover:bg-blue-50/40"
                >
                  <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-blue-700/10 text-blue-700">
                    <Icon className="h-6 w-6" />
                  </div>
                  <div>
                    <p className="font-mono text-[0.65rem] uppercase tracking-[0.2em] text-blue-700">{s.eyebrow}</p>
                    <h2 className="mt-2 font-display text-xl sm:text-2xl font-bold text-[#0A1F44] tracking-tight">{s.title}</h2>
                    <p className="mt-3 text-slate-600 leading-relaxed max-w-2xl">{s.desc}</p>
                    <p className="mt-4 font-mono text-[0.65rem] uppercase tracking-[0.18em] text-slate-600">{s.meta}</p>
                  </div>
                  <Link
                    to="/contact"
                    data-testid={`service-cta-${s.id}`}
                    className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-slate-300 px-5 py-2.5 text-sm text-[#0A1F44] transition-colors duration-200 hover:border-blue-600/60 hover:text-blue-700"
                  >
                    {s.cta} <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <CTABand />
    </>
  );
}
